<template>
  <div>
    <div
      class="input-group"
      :style="input.disabled || input.readonly ? 'pointer-events: none;' : ''"
    >
      <!-- <input class="form-control datepicker" :value="input.value" :placeholder="input.placeholder" :required="!input.optional" :disabled="input.disabled"> -->
      <b-form-datepicker
        :readonly="input.readonly"
        locale="id-ID"
        :id="input.id || String(Math.random(1023))"
        :value="value"
        class="form-control"
        :placeholder="input.placeholder"
        :required="!input.optional"
        :disabled="input.disabled"
        @context="handleChange"
        :name="input.name"
        reset-button
        nav-prev-year
        nav-next-year
        :show-decade-nav="true"
        :date-format-options="{
          year: 'numeric',
          month: 'short',
          day: '2-digit',
          weekday: 'short',
        }"
      >
        <slot name="nav-prev-decade"></slot>
        <slot name="nav-prev-year"></slot>
        <slot name="nav-next-year"></slot>
      </b-form-datepicker>
      <!--input type="date" format="YYYY/MM/DD" -->
    </div>
    <h5 v-if="input.age_count" class="text-muted mt-2">Usia: {{ age }}</h5>
  </div>
</template>
<script>
import { getAge } from "@/data/helper.js";
export default {
  name: "Datepicker",
  components: {},
  props: {
    input: Object,
    value: [String, Date],
  },
  data: function() {
    return {
      age: "",
    };
  },
  methods: {
    handleChange(e) {
      e.target = {
        value: e.selectedYMD,
        name: this.input.name,
      };
      if (this.input.age_count) {
        this.age = getAge(e.selectedYMD);
        // this.age = age ? (age+( 'tahun')) : ''
        ////console.log(e.target.value);
      }

      // e.target.value=e.selectedYMD;
      // e.target.name=this.input.name;
      this.$emit("handleChange", e);
    },
  },
};
</script>
<style></style>
